/**
 * firmaProjeListService.js — Firma tarafı "Projeler Listesi" (kart görünümü, stand bazlı)
 *
 * Route: /Firma/Projeler (FirmaProjelerListPage.jsx)
 *
 * standOverviewService.getStandOverviewList zaten her stand için standCategory/
 * floorInfo/projectType/projectStructure/standArea/projectHeightNumber (bkz.
 * _standListDesignOverrides) + fileApprovals/commitments/revisions'ı tek kayıtta
 * döndürüyor — firmaTalepListService'in aksine burada ayrı alt kaynakları
 * birleştirmeye gerek yok, bu dosya sadece ince bir sarmalayıcı (bkz. /fromImageToLayout
 * referans kartı — StandListPage.jsx'in "Liste" görünümüyle aynı alanlar, kart diliyse
 * FirmaTaleplerListPage'ten).
 *
 * #713: gateway'de `GET /firmalar/projeler` diye bir uç YOK ve hiç olmadı; liste canlıda roster'dan
 * (GET /standTalep/list, standOverviewService içinde) gelir. Eskiden burada kalıcı bir USE_MOCK_DATA bayrağı ve
 * o olmayan uca giden bir axios dalı vardı; ikisi de kaldırıldı.
 * WAS (until #713):
 *   const BASE = `${JAVA_BACKEND_API_URL}/firmalar/projeler`;
 *   export const USE_MOCK_DATA = true; // Backend hazır olunca false yap
 *   ... if (!USE_MOCK_DATA) { const response = await axios.get(BASE, { params, headers: getAuthHeader() }); return response.data; }
 */

import { getStandOverviewList } from './standOverviewService';

/**
 * Bu firmanın (seçili fuardaki) her standı için proje kartı — arama/sayfalama
 * standOverviewService.getStandOverviewList'e devredilir.
 */
export async function getFirmaProjeListesi(params = {}) {
  // #425 / #424: canlıda sayfa `firmaId` gönderir (firmanın her rolü); eski dal decoratorFirmaId ile süzerdi.
  const { fuarId, decoratorFirmaId, firmaId, search = '', page = 1, limit = 10, forceLive = false } = params;
  // WAS (until #425): return getStandOverviewList({ fuarId, decoratorFirmaId, search, page, limit, forceLive });
  return getStandOverviewList({ fuarId, decoratorFirmaId, firmaId, search, page, limit, forceLive });
}
